import { render, staticRenderFns } from "./service-view-page.vue?vue&type=template&id=2bd22204&"
import script from "./service-view-page.vue?vue&type=script&lang=js&"
export * from "./service-view-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports